import {Product} from './product';

// TODO: Review product limit rules. What if you want ot allow only one product from multiple categories and multiple products from one or more categories? Can it be configured manualy? What if the rule should apply only for certain categories? What other rules could share this mechanism? limit, exclude, update products, all of these could use a routing mechanism for categories. How can it be built in the most simple fashion? How other vendors have solved this issue?
// 
// export class CartRules {
//
//     // Category product limit is independent of subcategories.
//     limitOneProduct: boolean = false;
//
//     // 'self' - Limits one product in cart from current category
//     // 'eachSubCategory' - Limits one product in cart for each subcategory. Overrides subcategories settings.
//     // 'subcategories' - Categories that apply this rule.
//     // 'allSubCategories' - Limits one product in cart from all subcategories. Overrides subcategories settings.
//     // 'allSubCategoriesAndParent' - Limits one product in cart from all subcategories including parent category. Overrides subcategories settings.
//     productLimitScope: string = 'self';
// }


interface ProductCategoryConfig {
    _uuid?: number,
    id: string,
    parentCategoryId: string,
    menuName: string,
    title: string,
    subtitle: string,
    shortDescription: string,
    longDescription?: string,
    techSpecsLink: string,
    image: string,
    renderMode: string,
    customRenderer: string,
    isVisible: boolean
    allowInCartMultipleProds: boolean
    // cartRules: CartRules,
    sortOrder: number,
    zIndex: number,
}


export class ProductCategory {

    
    constructor (config: ProductCategoryConfig) {
        this._uuid = config._uuid;
        this._id = config.id;
        this.id = config.id;
        this.parentCategoryId = config.parentCategoryId;
        this.menuName = config.menuName;
        this.title = config.title;
        this.subtitle = config.subtitle;
        this.shortDescription = config.shortDescription;
        this.longDescription = config.longDescription;
        this.techSpecsLink = config.techSpecsLink;
        this.image = config.image;
        this.renderMode = config.renderMode;
        this.customRenderer = config.customRenderer;
        this.isVisible = config.isVisible;
        this.allowInCartMultipleProds = config.allowInCartMultipleProds;
        // this.cartRules = config.cartRules;
        this.sortOrder = config.sortOrder;
        this.zIndex = config.zIndex;
    }

    public _uuid?: number;
    public _id: string;
    public id: string;
    public parentCategoryId: string;
    public menuName: string;
    public title: string;
    public subtitle: string;
    public shortDescription: string;
    public longDescription?: string;
    public techSpecsLink: string;
    public image: string;
    public renderMode: string;
    public customRenderer: string;
    public isVisible: boolean;
    public allowInCartMultipleProds: boolean;
    public sortOrder: number; // . +/- 0
    public zIndex: number; // . +/- 0 // TODO: Decouple

    // Runtime values
    public products?: Array<Product>;
    public subcategories?: Array<ProductCategory>;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/classes/product-category.ts